import classNames from 'classnames';
import { Tabs, PartialWidthContainer, FlexContainer, Modal } from 'components';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useDataActions } from 'state';
import { SearchPropertyView } from '../bricks';
import { useSearchPropertyViewState } from '../state';
import styles from './SearchLayout.module.scss';

/**
 * SearchLayout
 *
 * @return {JSX.Element}
 */
const SearchLayout = ({ className, routes, children }) => {
  const storageAction = useDataActions();
  const searchPropertyViewState = useSearchPropertyViewState();
  const tabsOptions = useMemo(
    () =>
      routes.map((r) => ({
        ...r,
        key: r.path,
        value: r.title,
      })),
    [routes]
  );

  const handlePropertyViewClose = () => searchPropertyViewState.close();

  const handlePropertyToggleSaved = () =>
    searchPropertyViewState.state &&
    storageAction.property.toggleSaved(searchPropertyViewState.state.id);

  useEffect(() => {
    searchPropertyViewState.init();

    return () => searchPropertyViewState.destroy();
  }, [searchPropertyViewState]);

  const viewProperty = searchPropertyViewState.state;

  return (
    <PartialWidthContainer
      className={classNames(
        styles.SearchLayout,
        className,
        `${SearchLayout.displayName}`
      )}
      gap
      small
    >
      <Tabs className={styles.Header} options={tabsOptions} asNav />
      <FlexContainer className={styles.Body} column flex>
        {children}
      </FlexContainer>
      {viewProperty ? (
        <Modal onClose={handlePropertyViewClose} noPadding>
          <SearchPropertyView
            property={viewProperty}
            onClose={handlePropertyViewClose}
            onSave={handlePropertyToggleSaved}
          />
        </Modal>
      ) : null}
    </PartialWidthContainer>
  );
};

SearchLayout.displayName = 'SearchLayout';

export default observer(SearchLayout);
